import { useState } from 'react'

import { SortOrder } from '@utils/ApiClient'

export const useCampaignRebateSort = () => {
  const [sort, setSort] = useState<string>()
  const [sortOrder, setSortOrder] = useState<SortOrder>()
  const [isSortModalOpen, setSortModalOpen] = useState(false)
  return {
    closeSortModal: () => setSortModalOpen(false),
    isSortModalOpen,
    setSort,
    sort,
    sortOrder,
    setSortOrder,
    setSortModalOpen,
  }
}
